import type { App } from 'vue'
const baseUrl = import.meta.env.VITE_APP_RESOURCE_URL

const getImageUrl = (path: string) => {
  if (path.startsWith('http')) return path
  return `${baseUrl}${path}`
}
// 音乐克隆默认头像
export const BaseVoiceAvatar = `${baseUrl}/voice_avatar.png`

export default {
  install: (app: App) => {
    app.config.globalProperties.$imageUrl = getImageUrl
  },
  getImageUrl, // 导出方法供直接使用
}
